const FeedIcon = (props: any) => {
    return (
        <img {...props} alt="feed_icon.png" src={require('./feed_icon.png')} />
    );
};

export default FeedIcon;
